//
// privacy-policy.js
// Theme module
//

import { client, getSanityEditLink } from './sanity-client';

async function fetchPrivacyPolicy() {
    try {
        const query = `*[_type == "privacyPolicyPage"][0]{
            ...,
            showSections,
            sections[]{..., _key}
        }`;
        const data = await client.fetch(query);
        return data;
    } catch (error) {
        console.error('Error fetching privacy policy:', error);
        return null;
    }
}

function renderPrivacyPolicy(data) {
    if (!data) return;

    // Render Last Updated
    const lastUpdatedElement = document.getElementById('privacy-last-updated');
    if (lastUpdatedElement && (data._updatedAt || data.lastUpdated)) {
        if (data._id) {
            lastUpdatedElement.parentElement.classList.add('position-relative');
            lastUpdatedElement.insertAdjacentHTML('beforebegin', getSanityEditLink(data._id, 'privacyPolicyPage', 'lastUpdated', 'Edit Last Updated'));
        }
        const date = new Date(data._updatedAt || data.lastUpdated);
        const options = { day: '2-digit', month: 'short', year: 'numeric' };
        lastUpdatedElement.textContent = `Last updated: ${date.toLocaleDateString('en-GB', options)}`;
    }

    // Render Intro
    const introElement = document.getElementById('privacy-intro');
    if (introElement && data.intro) {
        if (data._id) {
            introElement.parentElement.classList.add('position-relative');
            introElement.insertAdjacentHTML('beforebegin', getSanityEditLink(data._id, 'privacyPolicyPage', 'intro', 'Edit Intro'));
        }
        introElement.textContent = data.intro;
    }

    // Render Sections
    if (data.showSections === false) {
        const sectionsContainer = document.getElementById('privacy-sections-container');
        if (sectionsContainer) sectionsContainer.style.display = 'none';
    } else {
        const sectionsContainer = document.getElementById('privacy-sections-container');
        if (sectionsContainer && data.sections) {
            let sectionsHtml = '';

            data.sections.forEach(section => {
                let itemsHtml = '';

                if (section.items) {
                    section.items.forEach(item => {
                        itemsHtml += `
                    <div class="row">
                        <div class="col-12 text-gray-700">
                        <div class="d-flex">
                            <!-- Check -->
                            <div class="badge badge-rounded-circle bg-primary-soft mt-1 me-4">
                            <i class="fe fe-check"></i>
                            </div>

                            <!-- Text -->
                            <p>${item.text}</p>
                        </div>
                        </div>
                    </div>
                    `;
                    });
                }

                sectionsHtml += `
            <section class="px-8 mb-6 position-relative">
                ${data._id && section._key ? getSanityEditLink(data._id, 'privacyPolicyPage', `sections[_key=="${section._key}"]`, 'Edit Section') : ''}
                <div class="container">
                    <div class="row">
                    <div class="col-12">
                        <h3 class="fw-bold text-black mb-4">
                        <span class="text-success">${section.heading}</span>
                        </h3>
                    </div>
                    </div>
                    ${itemsHtml}
                </div>
            </section>
            `;
            });

            sectionsContainer.innerHTML = sectionsHtml;
        }
    }
}

// Initialize
document.addEventListener('DOMContentLoaded', async () => {
    // Only run on the privacy policy page
    if (document.getElementById('privacy-sections-container')) {
        const data = await fetchPrivacyPolicy();
        renderPrivacyPolicy(data);
    }
});
